module.exports = __webpack_public_path__ + "ec3d9bfd0e4c12681c226e40c9ea0c69.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/soundway-hat.jpg
 ** module id = 457
 ** module chunks = 0
 **/